export default "__VITE_ASSET__XIPR01Uv__"